import React from "react";
import RegistrationFormComponent from "../component/RegistrationForm/RegistrationFormComponent";
import logo from "../assets/images/namochashak-logo-2.jpeg";

const RegistrationFormPage = () => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* <Header style={{ color: "white", width: "100%" }}> */}
        <img
          src={logo}
          alt="logo"
          style={{ height: "465px", width: "350px" }}
        />
        {/* </Header> */}
      </div>
      <RegistrationFormComponent />
    </div>
  );
};

export default RegistrationFormPage;
